module.exports = __webpack_public_path__ + "img/pdf.789732ef.jpg";